module.exports = __webpack_public_path__ + "img/artzie_logo_fi_cut.6b557f8b.png";